import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { HomeIcon, ClockIcon, CalendarIcon, CogIcon, UsersIcon, ChartBarIcon, LogoutIcon } from '@heroicons/react/outline';
import Logo from './Logo';
import { useLayout } from './Layout';
import { useAuth } from '../context/AuthContext'; // Importer le hook d'authentification

const Sidebar = ({ isSidebarOpen, setSidebarOpen }) => {
  const { counts } = useLayout();
  const { user, logout } = useAuth(); // Utiliser le hook pour récupérer l'utilisateur et la fonction logout
  const location = useLocation();
  
  const handleNavClick = () => {
    // Ferme le menu uniquement sur mobile
    if (window.innerWidth < 1024) { // 1024px est la breakpoint 'lg' dans Tailwind
      setSidebarOpen(false);
    }
  };

  const handleLogout = () => {
    logout(); // Appeler la fonction de déconnexion du contexte
  };

  const navItems = [
    { name: 'Accueil', href: '/', icon: HomeIcon, count: counts.total, current: location.pathname === '/' },
    { name: 'À traiter', href: '/a-traiter', icon: ClockIcon, count: counts.aTraiter, current: location.pathname === '/a-traiter' },
    { name: 'Plus tard', href: '/plus-tard', icon: ClockIcon, count: counts.plusTard, current: location.pathname === '/plus-tard' },
    { name: 'Rendez-vous', href: '/rendez-vous', icon: CalendarIcon, count: counts.rendezVous, current: location.pathname === '/rendez-vous' },
    { name: 'Agenda', href: '/agenda', icon: CalendarIcon, current: location.pathname === '/agenda' },
    { name: 'Utilisateurs', href: '/utilisateurs', icon: UsersIcon, current: location.pathname === '/utilisateurs' },
    { name: 'Statistiques', href: '/statistiques', icon: ChartBarIcon, current: location.pathname === '/statistiques' },
    { name: 'Paramètres', href: '/parametres', icon: CogIcon, current: location.pathname === '/parametres' },
  ];
  
  const sidebarContent = (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b">
        <Logo />
        {user && (
          <p className="mt-4 text-center text-sm text-gray-600">
            Bonjour, <span className="font-medium">{user.nom}</span>
          </p>
        )}
      </div>
      <nav className="flex-1 px-2 py-4 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            onClick={handleNavClick}
            className={({ isActive }) =>
              `flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 ${
                isActive
                  ? 'bg-blue-100 text-blue-600'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              }`
            }
          >
            <item.icon className="h-6 w-6 mr-3" />
            <span className="flex-1">{item.name}</span>
            {item.count !== undefined && (
              <span className={`px-2 py-0.5 ml-3 text-xs font-semibold rounded-full ${
                item.href === '/' ? 'bg-blue-200 text-blue-700' : 'bg-gray-200 text-gray-700'
              }`}>
                {item.count}
                </span>
              )}
          </NavLink>
        ))}
      </nav>

      {/* Section Déconnexion */}
      <div className="px-2 py-4">
        <button
          onClick={handleLogout}
          className="w-full flex items-center px-4 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150"
        >
          <LogoutIcon className="h-6 w-6 mr-3" />
          Se déconnecter
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* --- Barre latérale pour PC (fixe) --- */}
      <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 lg:border-r lg:border-gray-200 lg:bg-white">
        {sidebarContent}
      </div>

      {/* --- Tiroir pour Mobile --- */}
      {/* Overlay */}
      {isSidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-25 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      
      {/* Contenu du tiroir */}
      <div
        className={`fixed inset-y-0 left-0 w-64 bg-white shadow-xl z-30 transform transition-transform duration-300 ease-in-out lg:hidden
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
      >
        {sidebarContent}
    </div>
    </>
  );
};

export default Sidebar; 